import React, { useEffect, useState , useRef} from 'react';
import InputLinks from '../Assets/linksData'
import BackCard from '../Assets/backCard'
import { Fade } from 'react-reveal';
import { Button,  Dropdown, Flag, Icon, Input, Label, Loader, Tab } from 'semantic-ui-react';
import useGetArticles from '../../Dashboard/Assets/Hooks/fetchArticles';
import useGetClients from '../../Dashboard/Assets/Hooks/fetchClient';
import { toast } from 'react-toastify';
import GConf from '../../AssetsM/generalConf';
import axios from 'axios';
import FrameForPrint from '../../Dashboard/Assets/frameForPrint';
import usePrintFunction from '../../Dashboard/Assets/Hooks/printFunction';
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { Modal } from 'semantic-ui-react';
//import { io } from "socket.io-client";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";


 

function CaisseSimple() {
    /*#########################[Const]##################################*/
    //let request = window.indexedDB.open("Magazin", 2);
    //const socket = io.connect(GConf.ApiLinkSoket);
    const inputRef = useRef(null);
    const Today = new Date()
    let Offline = JSON.parse(localStorage.getItem(`Magazin_Caisse_Offline`));
    let caisseData = JSON.parse(localStorage.getItem(`Magazin_Caisse_LocalD`));
    const CaisseID = caisseData.C_ID;
    const [qrData, setQRData] = useState("Not Found")
    //const [stopStream, setStopStram] = useState(false)
    const [activeIndex, setActiveIndex] = useState(0);

    /*1- Ajouter Article */
    const [factureD, setFactureD] = useState({client:'PASSAGER', Caisse : CaisseID , jour: Today.toISOString().split('T')[0], totale: 0 , State:'' , Espece:'', Paye_Bons:'' , articles:[]})
    const [articleNow, setArticleNow] = useState([])
    const [articleList, setArticleList] = useState([])
    const [fastArticleList, setFastArticleList] = useState([])
    const [autofocusState, setAutoFocus] = useState(true)
    const [loadingPage, setLoadingP] = useState(true)

    const [keyBordI, setKeyBoedI] = useState('')
    const [floatOpen, setFloatOpen] = useState(false)
    const [peseState, setPeseState] = useState(false)

    let [rechercheKey, setRechercheKey] = useState('')
    const [rechercheList, setRechercheListe] = useState([])
    const [modalS, setModalS] = useState(false)
    const [modalT, setModaT] = useState(false)
    const [modalPS, setModaPS] = useState(false)
    const [modalSDX, setModalSDX] = useState(false)

    const [gettedFID, setFID] = useState('5555')
    const [toPrintFID, setToPrintFOD] = useState('5555')
    const [saveBtnState, setSaveBtnState] = useState(false)
    const [loaderState, setLS] = useState(false)
    
    const [layoutName, setLayoutName] = useState("default");

    /*2- Paymment */
    const [keyaPaymment, setKeyPaymment] = useState('')
    const [payBtnState, setPayBtnState] = useState(false)
    const sachetList = [
        {id:1, name:'Sac 100', valeur: 0.1},
        {id:1, name:'Sac 200', valeur: 0.2},
        {id:1, name:'Sac 300', valeur: 0.3},
        {id:1, name:'Sac 500', valeur: 0.5},
    ]
    const carteTicketsList = [
        {id:1, name:'Ticket 1250', valeur: 1.250},
        {id:1, name:'Carte 5700', valeur: 5.700},
    ]
    const [totSachetCarteList, setTotSachetCartList] =useState([])
    const [totSachetCarte, setTotSachetCart] =useState(0)
    

    const [selectedArticleList, setSelectedArticleList] = useState([])
    const [genreListe, setGenreList] = useState([
        {PK:1, Genre:'CAFE', tag:'Cafe',  Description:'kjhvuhv'},
        {PK:1, Genre:'BOISSON', tag:'Boisson',  Description:'kjhvuhv'},
        // {PK:1, Genre:'Boisson', tag:'Boisson',  Description:'kjhvuhv'},
        {PK:1, Genre:'CAKES', tag:'Cakes',  Description:'kjhvuhv'},
        {PK:1, Genre:'JOUET', tag:'JOUET',  Description:'kjhvuhv'},
    ])
     
    const [showKeyBoerd, sethowKeyBord] = useState(false)


    // useEffect(()=> {
    //     SetSelectedListeFunc('Cafe')
    // },[])


    /*4- Autres */
    const [factureOffline, setFactureOL] = useState(false)
    const panes = [
        {
            menuItem: { key: 'start', icon: 'add circle', content: 'Entrer ', className:`p-4 ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-1 text-white' : 'bg-ligth-theme-1' } ` }, 
            render: () => <Tab.Pane attached={false} className={`${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-1 text-white' : 'bg-ligth-theme-1' }`}> <BoissonListeInput /> </Tab.Pane>,
        },
        {
            menuItem: { key: 'articles', icon: 'bitcoin', content: 'Paymment ' , className:`p-4 ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-1 text-white' : 'bg-ligth-theme-1' } `  }, 
            render: () => <Tab.Pane attached={false} className={`${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-1 text-white' : 'bg-ligth-theme-1' }`}> <PaymmentCard />  </Tab.Pane>,
        },
            
    ]
    

    /*#########################[Use Effect]##################################*/
    useEffect(() => {
        axios.post(`${GConf.ApiCaisseLink}/nv/stock`, {
                TAG: 'cafe',
            })
            .then(function (response) {
                 setArticleList(response.data);
                 const selectedListe =  response.data.filter(article => article.Genre == 'Cafe')
                setSelectedArticleList(selectedListe)
                 
                 setLoadingP(false)
            }).catch((error) => {
                if(error.request) {
                  toast.error(<><div><h5>Probleme de Connextion</h5> La facture sera enregisstrer sur votre ordinateur  </div></>, GConf.TostInternetGonf)   
                  setLoadingP(false)
                }
            });
 
        //setClientList(Offline.client)
        

    }, [])


    /*#########################[Functions]##################################*/
    /*1- Ajouter Article */
    const AddArticleToList = () => {
        if (!articleNow.A_Code) {toast.error("Code à barre Invalide !", GConf.TostErrorCaisseGonf)}
        else if (!articleNow.Name || articleNow.Name == '') {toast.error("Name Invalide !", GConf.TostErrorCaisseGonf)}
        else if (!articleNow.Qte || articleNow.Qte == '') {toast.error("Quantite Invalide !", GConf.TostErrorCaisseGonf)}
        else{
            const searchObject = factureD.articles.find((article) => article.A_Code == articleNow.A_Code);
            if (searchObject) {
                let IndexOfArticle = factureD.articles.findIndex((article) => article.A_Code == articleNow.A_Code)
                factureD.articles[IndexOfArticle].Qte = factureD.articles[IndexOfArticle].Qte + parseInt(articleNow.Qte)
                factureD.articles[IndexOfArticle].PU = ((factureD.articles[IndexOfArticle].Qte) * factureD.articles[IndexOfArticle].Prix ).toFixed(3) 
                setArticleNow([{}])

                setFactureD({...factureD, totale: MakeSum() })
                setAutoFocus(false)
                
            } else {
                let prix_u = (articleNow.Qte * articleNow.Prix_piece).toFixed(3)
                let arrayToAdd = {id: factureD.articles.length+1 , A_Code: articleNow.A_Code, Name: articleNow.Name, Prix: articleNow.Prix_piece, Qte: parseInt(articleNow.Qte), PU: prix_u}
                factureD.articles.push(arrayToAdd)
                setArticleNow([])

                setFactureD({...factureD, totale: MakeSum() })
                setAutoFocus(false)    
            }
        }        
    }
    const DeleteFromUpdateListold = (value) =>{
        const searchObject = factureD.articles.findIndex((article) => article.A_Code == value);
        factureD.articles.splice(searchObject, 1);
        let resteArticles = factureD.articles;
       
        setFactureD({...factureD, articles: resteArticles })
        setFactureD({...factureD, totale: MakeSum() })
    }
    const DeleteFromUpdateListold2 = (value) =>{
        const newArticles = factureD.articles.filter(article => article.A_Code !== value);
        let resteArticles = newArticles;
        
        setFactureD({...factureD, articles: resteArticles })
        setFactureD({...factureD, totale: MakeSum() })
    }
    const DeleteFromUpdateListold3 = (value) => {
        const newArticles = factureD.articles.filter(article => article.A_Code !== value);
        setFactureD(prevState => ({ ...prevState, articles: newArticles }));
        
        let tot = 0
        newArticles.map( (art) => { 
            tot = tot +  parseFloat(art.PU)
        })

        setFactureD(prevState => ({ ...prevState, totale:tot.toFixed(3) }));
    };
    const DeleteFromUpdateList = (value) => {
        const newArticles = factureD.articles.filter(article => article.A_Code !== value);
    
        // Calculate the new total using reduce (better than map)
        const tot = newArticles.reduce((sum, art) => sum + parseFloat(art.PU || 0), 0).toFixed(3);
    
        // Update state in a single setFactureD call
        setFactureD(prevState => ({ 
            ...prevState, 
            articles: newArticles, 
            totale: tot 
        }));
    };
    // const DeleteFromUpdateList = (value) => {
    //     setFactureD((prevFactureD) => {
    //         const newArticles = prevFactureD.articles.filter(article => article.A_Code !== value);
    //         return {
    //             ...prevFactureD,
    //             articles: newArticles,
    //             totale: MakeSum()
    //         };
    //     });
    // };
    const GetArticleData = (value) =>{
        const searchObject= articleList.find((article) => article.A_Code == value);
        let Prix_piece = (searchObject.Prix_vente / searchObject.Groupage)
        searchObject.Prix_piece = Prix_piece.toFixed(3)
        setArticleNow(searchObject);
        setAutoFocus(true)
        
    }
    const MakeSum = () => {
        let tot = 0
        factureD.articles.map( (art) => { 
            tot = tot +  parseFloat(art.PU)
        })
        return (tot.toFixed(3))
    }
    const SaveFacture = () =>{
        if (!factureD.client) {toast.error("Client est Invalide !", GConf.TostErrorCaisseGonf)}
        else if (!factureD.jour ) {toast.error("Date est Invalide !", GConf.TostErrorCaisseGonf)}
        else if (!factureD.totale) {toast.error("totale est Invalide !", GConf.TostErrorCaisseGonf)}
        else if (!factureD.articles || factureD.articles.length == 0) {toast.error("article list est Invalide !", GConf.TostErrorCaisseGonf)}
        else {
            setLoadingP(true)
            setLS(true)
            setSaveBtnState(true)
            axios.post(`${GConf.ApiCaisseLink}/nv/ajouter`, {
                forPID: CaisseID,
                factureD: factureD,
            })
            .then(function (response) {
                if(response.status = 200) {
                    setSaveBtnState(true)
                    setFID(response.data.FID)
                    toast.dismiss();
                    toast.success("Facture Enregistreé !", GConf.TostSuucessCaisseGonf)
                    setLS(false)
                    setLoadingP(false)
                    setActiveIndex(1);
                }
                else{
                    toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessCaisseGonf)
                    setLS(false)
                    setSaveBtnState(false)
                }
            }).catch((error) => {
                if(error.request) {
                  toast.error(<><div><h5>Probleme de Connextion</h5> La facture sera enregisstrer sur votre ordinateur  </div></>, GConf.TostInternetGonf)   
                  let TID = Math.floor(Math.random() * 1111111111111)
                  Offline.factureToSave.push({ ...factureD, Pay_State : 'Waitting',  T_ID: TID,  T_Time : new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }), T_Date: new Date().toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' )})
                  setFID(TID)
                  localStorage.setItem(`Magazin_Caisse_Offline`,  JSON.stringify(Offline));
                  setLS(false)
                  setLoadingP(false)
                }
            });

        }       
    }
    const BtnClicked = (value) =>{
        //socket.emit('cmd-saved', {message: value})
        if (value === 'C') { 
            setKeyBoedI('') 
            //alert(inputRef.current.value)
            inputRef.current.value = ''
            inputRef.current.focus()
        } 
        else if (value === '.' ) { 
            //setKeyBoedI(parseFloat(keyBordI)) 
            //alert(parseFloat(keyBordI))
            setFloatOpen(true)
        } 
        else {
            //setKeyBoedI(Number(keyBordI+value)) 
             
            if (floatOpen) {
                setKeyBoedI(prevInput => prevInput + '.' + parseFloat(value))
                setFloatOpen(false)
            } else {
                setKeyBoedI(prevInput => prevInput + parseFloat(value))
            }
        }
    }
    const RemoveOneCaracter = () => {
        setKeyBoedI(prevInput => prevInput.slice(0, -1));  // Remove the last character
        inputRef.current.value = inputRef.current.value.slice(0, -1); // Update input field too
        inputRef.current.focus();
    }
    const EnterKyPressed = (e) =>{
        if (e.which == 13) {
            // if (e.getModifierState('CapsLock')) {
            //     //setKeyBoedI(e.target.value)
                
            // } else {
            //     toast.error(<>
            //         <div className='card-body w-100 text-center'>
            //             <span className='bi bi-keyboard-fill bi-lg'></span> 
            //             <h3 className='text-white'>Activer Majuscule</h3> 
            //         </div>
            //         </>, GConf.TostCaisseGonf)
                    
            // }
            GetArticleDataByAID(e.target.value)
         }  
         else if (e.which == 32) {
            if (factureD.articles.length != 0) {
                const lastElement = factureD.articles[factureD.articles.length - 1]
                AddMoreQte(lastElement.A_Code,e.target.value)
            }
         }
         else {
             //console.log(e.which)
         } 
            
    }
    const GetArticleDataByAID = (barCodeValue) =>{
        if (peseState) {
            let barreCode = barCodeValue.toString().substring(0, 7)
            let qte = (barCodeValue.toString().substring(7) / 10000).toFixed(3)
            const searchObjectFirst= articleList.find((article) => article.A_Code == barreCode);
            if (searchObjectFirst) {
                const searchObject = factureD.articles.find((article) => article.A_Code == barreCode);
                if (searchObject) {
                    let IndexOfArticle = factureD.articles.findIndex((article) => article.A_Code == barreCode)
                    factureD.articles[IndexOfArticle].Qte = (parseFloat(factureD.articles[IndexOfArticle].Qte) + parseFloat(qte)).toFixed(3)
                    factureD.articles[IndexOfArticle].PU = ((factureD.articles[IndexOfArticle].Qte) * factureD.articles[IndexOfArticle].Prix ).toFixed(3) 
                    setArticleNow([{}])

                    setFactureD({...factureD, totale: MakeSum() })
                    setAutoFocus(false)
                    setKeyBoedI('')

                    setPeseState(false)
                    
                } else {
                    let arrayToAdd = {id: factureD.articles.length+1 , A_Code: barreCode, Name: searchObjectFirst.Name, Prix: searchObjectFirst.Prix_vente, Qte: qte, PU: (searchObjectFirst.Prix_vente * qte)}
                    factureD.articles.push(arrayToAdd)
                    setArticleNow([])

                    setFactureD({...factureD, totale: MakeSum() })
                    setAutoFocus(false)   
                    setKeyBoedI('')

                    setPeseState(false)
                }

            } else {
                toast.error(<>
                            <div className='card-body w-100 text-center'>
                                <span className='bi bi-box-seam bi-lg'></span> 
                                <h3 className='text-white'>Pas D'article</h3> 
                            </div>
                            </>, GConf.TostCaisseGonf)
            } 
        } else {
            const searchObjectFirst= articleList.find((article) => article.A_Code == barCodeValue);
            if (searchObjectFirst) {
                const searchObject = factureD.articles.find((article) => article.A_Code == barCodeValue);
                if (searchObject) {
                    let IndexOfArticle = factureD.articles.findIndex((article) => article.A_Code == barCodeValue)
                    factureD.articles[IndexOfArticle].Qte = factureD.articles[IndexOfArticle].Qte + 1
                    factureD.articles[IndexOfArticle].PU = ((factureD.articles[IndexOfArticle].Qte) * factureD.articles[IndexOfArticle].Prix ).toFixed(3) 
                    setArticleNow([{}])

                    setFactureD({...factureD, totale: MakeSum() })
                    setAutoFocus(false)
                    setKeyBoedI('')
                    
                    
                } else {
                    let arrayToAdd = {id: factureD.articles.length+1 , A_Code: barCodeValue, Name: searchObjectFirst.Name, Prix: searchObjectFirst.Prix_vente, Qte: 1, PU: searchObjectFirst.Prix_vente}
                    factureD.articles.push(arrayToAdd)
                    setArticleNow([])

                    setFactureD({...factureD, totale: MakeSum() })
                    setAutoFocus(false)   
                    setKeyBoedI('') 
                    
                }

            } else {
                toast.error(<>
                            <div className='card-body w-100 text-center'>
                                <span className='bi bi-box-seam bi-lg'></span> 
                                <h3 className='text-white'>Pas D'article</h3> 
                            </div>
                            </>, GConf.TostCaisseGonf)
                            
            }    
        }
        console.log(factureD.articles)
    }
    const AddPtixLibre = (wantedPrice) => {
        if (wantedPrice) {
            let arrayToAdd = {id: factureD.articles.length + 1 , A_Code: 97913914, Name: 'Article Prix Libre', Prix: parseFloat(wantedPrice), Qte: 1, PU: parseFloat(wantedPrice)}
            factureD.articles.push(arrayToAdd)
            setArticleNow([])

            setFactureD({...factureD, totale: MakeSum() })
            setAutoFocus(false)   
            setKeyBoedI('') 
        } else {
            toast.error("Entrer le Prix !", GConf.TostErrorCaisseGonf)
        }
        
    }
    const ActivateCapLock = () => {
        var event = new KeyboardEvent('keydown', {'keyCode': 20, 'which': 20});
        document.dispatchEvent(event);
        alert('gg')
    }
    const FireKeyPosBtn = () => {
       
    }
    const AddMoreQte = (valueCode, qte) =>{
        if (qte == '' || qte == '0') {
            toast.error(<>
                <div className='card-body w-100 text-center'>
                    <span className='bi bi-box-seam bi-lg'></span> 
                    <h3 className='text-white'>Entrez Quantite</h3> 
                </div>
                </>, GConf.TostCaisseGonf)
        } else {
            console.log(qte)
            let IndexOfArticle = factureD.articles.findIndex((article) => article.A_Code == valueCode)
            factureD.articles[IndexOfArticle].Qte =  parseFloat(qte)
            factureD.articles[IndexOfArticle].PU = ((factureD.articles[IndexOfArticle].Qte) * factureD.articles[IndexOfArticle].Prix ).toFixed(3) 
            setArticleNow([{}])
    
            setFactureD({...factureD, totale: MakeSum() })
            setAutoFocus(false)
            setKeyBoedI('')
        }
       
    }
    const RechercheFunction = () => {
        if (!rechercheKey) { toast.warning('non') } 
        else {
            let values = articleList.filter(element => element.Name.toLowerCase().includes(rechercheKey.toLowerCase()));
            setRechercheListe(values)
        }
        
    }
    const NewTicket = () =>{
        // setLoadingP(true)
        // setTimeout(() => {
        //     setLoadingP(false);
        // }, 500);
        // setFactureD({client:'PASSAGER', Caisse : CaisseID , jour: Today.toISOString().split('T')[0], totale: 0 , articles:[]})
        // setArticleNow([])
        // setAutoFocus(true)
        // setKeyBoedI('')
        // setFloatOpen(false)
        // setPeseState(false)
        // setRechercheKey('')
        // setRechercheListe([])
        // setModalS(false)
        // setModaT(false)
        // setFID('')
        // setSaveBtnState(false)
        // setLS(false)
        // setKeyPaymment(0)
        // setSelectedBon(1)
        window.location.reload()
        
    }
    const SetSelectedListeFunc = (selectedGenre) =>{
        const selectedListe =  articleList.filter(article => article.Genre == selectedGenre)
        setSelectedArticleList(selectedListe)
    }

    /*2- Paymment */
    const PaymmentBtnClicked = (value) =>{
        if (value === 'C') { 
            setKeyPaymment('') 
        } 
        else if (value === '.' ) { 
            setFloatOpen(true)
        } 
        else {             
            if (floatOpen) {
                setKeyPaymment(prevInput => prevInput + '.' + parseFloat(value))
                setFloatOpen(false)
            } else {
                setKeyPaymment(prevInput => prevInput + parseFloat(value))
            }
        }
    }
    const SavePaymmentCache = () =>{

        if (!gettedFID || gettedFID == '') {toast.error("Une Erreur s'est Produit !", GConf.TostErrorCaisseGonf)}
        else if (keyaPaymment == '') {toast.error("Solde Insufisante !", GConf.TostErrorCaisseGonf)}
        else if (JSON.parse(factureD.totale) > JSON.parse(keyaPaymment)) {toast.error("Solde Insufisante !", GConf.TostErrorCaisseGonf)}
        else {
            setLoadingP(true)
            axios.post(`${GConf.ApiCaisseLink}/nv/payee/espece`, {
                forPID: CaisseID,
                espece: keyaPaymment,
                fid : gettedFID
            })
            .then(function (response) {
                if(response.status = 200) {
                    setPayBtnState(true)
                    toast.dismiss();
                    toast.success("Facture Payeé !", GConf.TostSuucessCaisseGonf)
                    setLoadingP(false)
                    setToPrintFOD(gettedFID)
                }
                else{
                    toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessCaisseGonf)
                    setLoadingP(false)
                }
            }).catch((error) => {
                if(error.request) {
                  toast.error(<><div><h5>Probleme de Connextion</h5> Paymment à été enregistre localmment   </div></>, GConf.TostInternetGonf)   
                   let targetElm = Offline.factureToSave.find((data) => data.T_ID = gettedFID)
                   //Offline.factureToSave[gettedFID].Espece = keyaPaymment
                   //Offline.factureToSave[gettedFID].Pay_State = 'Payee'
                   targetElm.Espece = keyaPaymment
                   targetElm.Pay_State = 'Payee'
                   localStorage.setItem(`Magazin_Caisse_Offline`,  JSON.stringify(Offline));
                   setLoadingP(false)
                   setPayBtnState(true)
                }
            });

        }
    }
    const GetSacCarteNum = (valueSelected) => {
        const totInList = totSachetCarteList.filter((data) => data.value == valueSelected)
        if (totInList && totInList.length != 0) {
            return(totInList.length)
        } else {
            
        }
        
        //return totInList.length
    }
    const CaluculateSumSacCarte = () => {
        let tot = 0
        totSachetCarteList.map((data) => tot = tot + data.value )
        setTotSachetCart(tot)
    }

    /* Autres */
    const PrintFunction = (frameId) =>{ usePrintFunction(frameId)}


    /*#########################[Component]##################################*/ 
    const ProgressLoadingBar = (props) =>{
        return(<>
            <div className={`progress-bar-loading ${props.display == true ? '': 'd-none'}`} style={{marginTop:'1px'}}>
                    <div className="progress-bar-loading-value bg-danger"></div>
                </div>
            </>)
    }
    
    

    /*1- Ajouter Article */
    const BoissonListeInput = () =>{

            const GenreListeCard = (props) =>{
                return(<>
                    <div className={`card card-body mb-1  text-danger text-center btn ${GConf.themeMode == 'dark' ? 'bg-dark-theme-3 text-white' : 'bg-ligth-theme-3' }`} onClick={() => SetSelectedListeFunc(props.text.tag)}> <h3> {props.text.Genre} </h3></div>
                </>)
            }
            const ArticleItemCard = (props) =>{
                return(<>
                    <div className='col-6 col-lg-3 mb-1'>
                        <div className={`card p-1 text-secondary  h-100 border-div btn `} style={{backgroundColor : props.data.Color_Val}} onClick={() => GetArticleDataByAID(props.data.A_Code)}>
                            <div className='row'>
                                <div className='col-12 text-end text-white'><b><h4>{props.data.Prix_vente.toFixed(3)}</h4></b></div>
                                <div className='col-12 mb-2'><b><img className='rounded-circle' src={`https://assets.ansl.tn/Images/cafe/${props.data.Photo_Path}`} width='100px' height='100px' /></b></div>
                                <div className='col-12'><h5 className='text-white'>{props.data.Name}</h5></div>
                            </div>
                            
                        </div>
                    </div>
                </>)
            }

            return(<>
                <div className='row'>
                        <div className='col-4'><Button disabled={saveBtnState && !payBtnState} fluid style={{height:'40px'}} className='rounded-pill bg-primary text-white mb-3' onClick={()=> NewTicket()}>  <Icon name='redo' /> N. Ticket</Button></div> 
                        <div className='col-2'><Button  fluid style={{height:'40px'}} className='rounded-pill bg-warning mb-3' onClick={() =>PrintFunction('openCaisse')}>  <Icon name='lock open' /> </Button></div> 
                        <div className='col-5'><Button disabled={saveBtnState} fluid style={{height:'40px'}} className='rounded-pill bg-system-btn' onClick={() => SaveFacture()}>  <Icon name='save' /> Valideé Pour PASSAGER <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button></div>
                        <div className='col-1'><Button icon className={` ${showKeyBoerd  ? 'bg-warning text-danger' : GConf.themeMode == 'dark' ? 'bg-dark-theme-3 text-white' : 'bg-ligth-theme-3' } }`} onClick={() => sethowKeyBord(!showKeyBoerd)}> <Icon name='keyboard' /> </Button></div>
                        <div className='col-3 d-none'><Button disabled={saveBtnState} fluid style={{height:'40px'}} className='rounded-pill bg-system-btn mb-3' onClick={() => setModaT(true)}>  <Icon name='search' /> Trouver  </Button></div>
                </div>
                <div className='row'>
                    <div className='col-12 col-lg-3 spesific-commp-2' style={{height: '58vh', overflow: 'scroll', overflowX:'hidden'}}>
                        {
                            genreListe.map((data,index) => <GenreListeCard key={index} text={data} /> )
                        }
    
                    </div>
                    <div className='col-12 col-lg-9'>
                        <div className='row'>
                            {
                                showKeyBoerd ? 
                                <>
                                    <h2><span className='bi bi-keyboard'></span>  : {keyBordI}</h2>
                                    <ClavierCard />
                                </>
                                :
                                <>{selectedArticleList.map((data,index) => <ArticleItemCard key={index} data={data} />)}</> 
                                 
                            }
                        </div>
                        
                    </div>
                </div>
            </>)
    }
    const AddArticles = ({}) =>{
        return (<>
                <div className='row'>
                    <div className='col-12 col-md-5'>
                        <div className='mb-2'>
                            <div className='row'>
                                    <div className='col-8'><Button disabled={saveBtnState && !payBtnState} fluid style={{height:'40px'}} className='rounded-pill bg-system-btn mb-3' onClick={()=> NewTicket()}>  <Icon name='redo' /> N. Ticket</Button></div> 
                                    <div className='col-4'><Button  fluid style={{height:'40px'}} icon className='rounded-pill bg-system-btn mb-3' onClick={() =>PrintFunction('openCaisse')}>  <Icon name='lock open' /> </Button></div> 
                            </div> 
                            
                            <h2><span className='bi bi-keyboard'></span>  : {keyBordI}</h2>
                            {/* <Input type='number' inputRef={inputRef}  size='massive'  icon='barcode'   onKeyPress={(e) => EnterKyPressed(e)}  autoFocus={true}   iconPosition='left' placeholder=' '  fluid className='mb-1' /> */}
                            <input type='text' className='form-control form-control-lg'  ref={inputRef} onKeyPress={(e) => EnterKyPressed(e)} autoFocus={true} />
                            <br />
                            <div className='row '>
                                <div className='col-6'>
                                    <Button disabled={saveBtnState} fluid style={{height:'50px'}} className='border-div bg-system-btn' onClick={() => GetArticleDataByAID(keyBordI)}>  <Icon name='check' /> Ajouter</Button>
                                </div>
                                <div className='col-6'>
                                    <Button disabled={saveBtnState} fluid style={{height:'50px'}} className={`border-div ${peseState ? 'bg-warning text-white' : 'bg-white border '}`} onClick={() => setPeseState(!peseState)}>  <Icon name='balance' /> Pesé </Button>
                                </div>
                                <div className='col-12'>
                                    <Button disabled={saveBtnState} fluid style={{height:'40px'}} className={`border-div mt-3 bg-primary text-white`} onClick={() => AddPtixLibre(keyBordI)}>  <Icon name='dollar' /> PRIX LIBRE </Button>
                                </div>
                            </div>
                            <h5>Enregistrer </h5> 
                            <Button disabled={saveBtnState} fluid style={{height:'50px', backgroundColor: '#f20a19'}} className='rounded-pill text-white' onClick={() => SaveFacture()}>  <Icon name='save' /> Valideé Pour PASSAGER <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                            
                            
                            <div className='row mt-3'>
                                <div className='col-6'><Button disabled={saveBtnState} fluid icon  style={{height:'40px', backgroundColor: '#fcf932'}} className='rounded-pill text-dark' onClick={() => localStorage.setItem('pauseList', JSON.stringify(factureD.articles) )} >  <Icon name='pause' />    </Button></div>
                                <div className='col-6'><Button disabled={saveBtnState} fluid icon style={{height:'40px', backgroundColor: '#e30e91'}} className='rounded-pill text-dark' onClick={() => setFactureD({...factureD,  articles : JSON.parse(localStorage.getItem('pauseList'))})}>  <Icon name='play' />    </Button></div>
                            </div>

                        </div>
                    </div>
                    <div className='col-12 col-md-7 align-self-center'>
                       <div className='row'>
                            <div className='col-6'><Button disabled={saveBtnState} fluid style={{height:'40px', backgroundColor: '#04cfa3'}} className='rounded-pill text-dark mb-3' onClick={() => setModalS(true)}>  <Icon name='search' /> Recherche </Button></div>
                            <div className='col-6'><Button disabled={saveBtnState} fluid style={{height:'40px', backgroundColor: '#cf4804'}} className='rounded-pill text-dark mb-3' onClick={() => setModaT(true)}>  <Icon name='magic' /> Code Facile  </Button></div>
                        </div> 
                        <ClavierCard /> 
                        <div className='row mt-5'></div>
                    </div>
                </div> 
                
        </>)
    }
    const ArticleListCard = (props) =>{
        return(<>
                    <div className={`card shadow-sm p-2 mb-1 me-1 border-div  ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-4 text-white' : 'bg-ligth-theme-4' } `} >
                        <div className='row p-0'>
                            <div className='col-10 text-start align-self-center ps-4'>
                                <div className='text-truncate' style={{maxWidth : '95%'}} >{props.dataA.Name}</div>
                                <b className='text-blod'><span style={{color:'#f5b402'}}>{props.dataA.Qte}</span></b> x {props.dataA.Prix.toFixed(3)} = <span style={{color:'#c42e04'}}>{parseFloat(props.dataA.PU).toFixed(3)}</span>
                            </div>
                            <div className='col-2 align-self-center text-start'><Button disabled={saveBtnState} onClick={() => DeleteFromUpdateList(props.dataA.A_Code)} icon="times" className='rounded-circle p-2 text-white bg-danger'></Button></div>

                            {/* <div className='col-3 align-self-center m-0'><Button disabled={saveBtnState} fluid onClick={() => AddMoreQte(props.dataA.A_Code,keyBordI)} icon="plus cart" className='rounded   text-white bg-info'></Button></div> */}
                            {/* <div className='col-3 align-self-center m-0'><img src={`https://assets.ansl.tn/Images/cafe/${props.data.Photo_Path}`} width='20px' height='20px' /></div> */}
                            {/* <div className='col-2 align-self-center m-0'><Button disabled={saveBtnState} onClick={() => AddMoreQte(props.dataA.A_Code,keyBordI)} icon="plus cart" className='rounded-circle p-2 text-white bg-info'></Button></div> */}
                        </div>
                    </div>
                </>)
    }
    const TotaleCard = () =>{
        return(<>
                <div className={`card card-body shadow-sm mb-2 sticky-top border-div ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-3 text-white' : 'bg-ligth-theme-3' } `} style={{top:'70px'}}>
                    <div className='row'>
                        <div className='col-9 align-self-center text-start'><h1>Totale : {factureD.totale}</h1></div>
                        <div className='col-3 align-self-center text-center'><h5 className='mb-0'>{factureD.articles.length}</h5> articles</div>
                    </div>
                    
                   
                </div>
            </>)
    }
    const ClavierCard = () =>{
        const BtnCard = (props) =>{
            return(<>
                <Button className={`shadow-sm ${props.bg == true ? 'bg-danger text-white ' : InputLinks.themeMode == 'dark' ? 'bg-dark-theme-3 text-white border-dark' : 'bg-white' } border mb-1 border-div `} style={{width:'100%', height:'60px', backgroundColor:'red'}} onClick={(e) => BtnClicked(props.value) } ><h2>{props.value}</h2></Button>
            </>)
        }
        const BtnCardSped = (props) =>{
            return(<>
                <Button className={`shadow-sm ${props.bg == true ? 'bg-danger text-white ' : InputLinks.themeMode == 'dark' ? 'bg-dark-theme-3 text-white border-dark' : 'bg-white' } border mb-1 border-div `} style={{width:'100%', height:'60px', backgroundColor:'red'}} onClick={(e) => RemoveOneCaracter() } ><h2>{props.value}</h2></Button>
            </>)
        }
        return(<>
            <div className='row '>
                <div className='col-4 p-2'><BtnCard value='1' /></div>
                <div className='col-4 p-2'><BtnCard value='2' /></div>
                <div className='col-4 p-2'><BtnCard value='3' /></div>
                <div className='col-4 p-2'><BtnCard value='4' /></div>
                <div className='col-4 p-2'><BtnCard value='5' /></div>
                <div className='col-4 p-2'><BtnCard value='6' /></div>
                <div className='col-4 p-2'><BtnCard value='7' /></div>
                <div className='col-4 p-2'><BtnCard value='8' /></div>
                <div className='col-4 p-2'><BtnCard value='9' /></div>
                <div className='col-4 p-2'><BtnCard value='0' /></div>
                <div className='col-4 p-2'><BtnCard value='.' bg={floatOpen} /></div>
                <div className='col-4 p-2'><BtnCard value='C' /></div>
                <div className='col-6 p-2'><BtnCard value='619' /></div>
                <div className='col-6 p-2'><BtnCardSped value='<' /></div>
            </div>
        </>)
    }
    

    /*2- Paymment */
    const ClavierPaymmentCard = () =>{
        const BtnCard = (props) =>{
            return(<>
                <Button className={`shadow-sm ${props.bg == true ? 'bg-danger text-white ' : InputLinks.themeMode == 'dark' ? 'bg-dark-theme-3 text-white border-dark' : 'bg-white' } border mb-1 border-div `} style={{width:'100%', height:'60px', color:  props.selectedBg ? props.selectedBg : '' }} onClick={(e) => PaymmentBtnClicked(props.value) } ><h2>{props.value}</h2></Button>
            </>)
        }
        return(<>
            <div className='row '>
                <div className='col-4 p-2'><BtnCard value='1' /></div>
                <div className='col-4 p-2'><BtnCard value='2' /></div>
                <div className='col-4 p-2'><BtnCard value='3' /></div>
                <div className='col-4 p-2'><BtnCard value='4' /></div>
                <div className='col-4 p-2'><BtnCard value='5' /></div>
                <div className='col-4 p-2'><BtnCard value='6' /></div>
                <div className='col-4 p-2'><BtnCard value='7' /></div>
                <div className='col-4 p-2'><BtnCard value='8' /></div>
                <div className='col-4 p-2'><BtnCard value='9' /></div>
                <div className='col-4 p-2'><BtnCard value='0' /></div>
                <div className='col-4 p-2'><BtnCard value='.'  bg={floatOpen} /></div>
                <div className='col-4 p-2'><BtnCard value='00' /></div>
                <div className='col-4 p-2'><BtnCard value='10' selectedBg = '#eb3d34' /></div>
                <div className='col-4 p-2'><BtnCard value='20' /></div>
                <div className='col-4 p-2'><BtnCard value='50' /></div>
            </div>
        </>)
    }
    const PaymmentCard = ({}) =>{
        return (<>
                <div className='row'>
                    <div className='col-12 col-md-7 align-self-center'>
                        {/* <Button  disabled={payBtnState || !saveBtnState} fluid style={{height:'40px'}} className='rounded-pill bg-system-btn mb-3' onClick={() => setModalSDX(true)}>  <Icon name='credit card' /> CARTE SODEXO </Button> */}
                        {/* <Button disabled={payBtnState || !saveBtnState} fluid style={{height:'40px'}} className='rounded-pill bg-system-btn mb-3' onClick={() => setModalSDX(true)}>  <Icon name='credit card' /> CARTE SODEXO </Button> */}
                        <ClavierPaymmentCard /> 
                    </div>
                    <div className='col-12 col-md-5'>
                        <div className='mb-2'>
                            {/* <Button  fluid style={{height:'40px'}} className='rounded-pill bg-system-btn mb-3' onClick={() => setModaPS(true)}>  <Icon name='search' /> Sahcet & Carte de Recharge </Button> */}
  
                            <h3 className='mb-2'>Totale : {factureD.totale}</h3> 
                            <h3 className='mb-2 mt-1'>Reste : {(keyaPaymment - factureD.totale).toFixed(3)}</h3> 
                                <div className='row'>
                                    <div className='col-9'><Input type='number' size='huge'  icon='money' value={keyaPaymment} onKeyPress={(e) => EnterKyPressed(e)} autoFocus={true} onChange={ (e) => {setKeyPaymment(Number(e.target.value)) }}   iconPosition='left' placeholder=' '  fluid className='mb-1' /></div>
                                    <div className='col-3 ms-0 me-0'> <Button disabled={false} icon fluid className='border-div   text-white' style={{height:'50px', backgroundColor : InputLinks.themeMode == 'dark' ? '#96999e': '#343536'}} onClick={() => setKeyPaymment('')}> <h2>C</h2> </Button> </div>
                                    
                                </div>
                                
                            <br />
                            <div className='row'>
                                <div className='col-12'>
                                    <Button disabled={payBtnState || !saveBtnState} fluid style={{height:'50px', backgroundColor: '#00118f'}} className='border-div text-white' onClick={() => SavePaymmentCache()}>  <Icon name='check' /> Payeé</Button>
                                </div>
                            </div>
                            <h5>Imprimer</h5> 
                            <div className='row'>
                                <div className='col-9'><Button disabled={!saveBtnState || !payBtnState} fluid style={{height:'40px'}} className='rounded-pill bg-system-btn mb-3' onClick={() => PrintFunction('printFacture')}>  <Icon name='print' /> Imprimer </Button></div>
                                <div className='col-3 text-center'><Button  disabled={!saveBtnState || !payBtnState} icon fluid style={{height:'40px'}} className='rounded-pill bg-system-btn mb-3' onClick={() => PrintFunction('openCaisse') }>  <Icon name='lock open' /> </Button></div> 
                                <div className='col-12'><Button  fluid style={{height:'40px'}} disabled={!saveBtnState || !payBtnState} className='rounded-pill bg-primary text-white mb-3' onClick={() => NewTicket() }>  <Icon name='redo' /> Nouveaux Ticket  </Button></div> 
                            </div>
                            
                        </div>
                    </div>
                </div> 
                
        </>)
    }
    const ShachetCardList = (props) => {
        const AddValueToTotale = (valueSelected) =>{
            totSachetCarteList.push({value: valueSelected})
            CaluculateSumSacCarte()
        }
        return (<>
        <div className={`${props.carteEtTicket ?'col-6' :'col-6'}`}>
            <div className='card card-body shadow-sm mb-3 border-div text-center' onClick={() => AddValueToTotale(props.data.valeur)} >
               <h3> <span className='badge bg-danger rounded-circle'>{GetSacCarteNum(props.data.valeur)}</span>  {props.data.name}</h3>
            </div>
        </div>
        </>)
    }
     
 
    
    return (  <>
        <div className={`${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-2' : 'bg-ligth-theme-2' }`} style={{height: '100vh', overflow: 'scroll'}}>
            <BackCard  data={InputLinks.backCard.nv}/>
            <ProgressLoadingBar  display={loadingPage} />
            <br />
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 col-md-3'>
                        <TotaleCard /> 
                        <div className='spesific-commp' style={{height: '70vh', overflow: 'scroll', overflowX:'hidden'}}>
                            {factureD.articles.slice().reverse().map( (val,index) => <ArticleListCard key={index} dataA={val}/>)}
                            <br />
                        </div>   

                        
                    </div>
                    <div className='col-12 col-md-9'>
                        <Tab activeIndex={activeIndex} onTabChange={(e, data) => setActiveIndex(data.activeIndex)} menu={{ widths: panes.length , pointing: true  , className: InputLinks.themeMode == 'dark' ? 'bg-dark-theme-1 text-white' : 'bg-ligth-theme-1' }} panes={panes} />
                    </div>
                </div>
            </div>
        </div>
 
        <FrameForPrint frameId='printFacture' src={`/Pr/caisse/facture/${toPrintFID}`} />
        <FrameForPrint frameId='openCaisse' src={`/Pr/caisse/open`} />
        
    </>);
}


export default CaisseSimple;